/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:57:05
 */
import axios from 'axios'
import router from '@/router'
import Vue from 'vue'
import i18n from '@/i18n'
import { gwInitA, gwInitB, gwRequest } from './signVerify'
import { ERROR_CONFIG_MAP } from '@/config/error'
import { uuid } from './wrapperUtil'

// 不拦截code的接口
const releaseUrl = ['/commodity/Pay'] // 支付接口不拦截

// 传加密后的应用id和密钥secret
gwInitA(['c%7C%7E%88%7Bjj%7Cxjhsuxuu%85%82qbk%7B%83%83tings%8', '%8', '%7B'])
gwInitB(['84tcdhh', '83sdfywaq', '7Dihy', '7Bxmiegtrdx', '7Eih', 'f'])
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 180
})

axiosInstance.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.headers['Trace-Id'] = uuid()
  }
  return gwRequest(config)
}, function (error) {
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use(function (response) {
  const data = response.data
  const code = data.code
  if (code !== 1012 && releaseUrl.includes(response.config.url)) {

  } else if (ERROR_CONFIG_MAP[code]) {
    Vue.prototype.$info({
      content: (h) => {
        return (
          <div class="error">
            <div class="desc">{(new Vue({ i18n })).$t(ERROR_CONFIG_MAP[code])}</div>
            <div class="code">{'code:' + code}</div>
          </div>
        )
      },
      okText: (new Vue({ i18n })).$t('ok')
    })
    if (code === 1012) {
      router.replace({ name: 'ThirdPartChannel' })
      window.sessionStorage.clear()
    }
  } else if (code !== 0) {
    // 服务异常
    Vue.prototype.$info({
      content: (h) => {
        return (
          <div class="error">
            <div class="desc">{(new Vue({ i18n })).$t('server_err')}</div>
            <div class="code">{'code:' + code}</div>
          </div>
        )
      },
      okText: (new Vue({ i18n })).$t('ok')
    })
    // <div class="code">{'code:' + code}</div>
  }
  return response.data
}, function (error) {
  return Promise.reject(error)
})

// 设置默认值
if (window.sessionStorage.token) {
  axiosInstance.defaults.headers.common['Access-Token'] = window.sessionStorage.token
}

export default axiosInstance
